import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Disease from './components/Disease';
import { handleFieldChange } from './helpers/HandleFieldChange';
import '../styles/OnlineForm.css'
import FormHeader from './components/FormHeader';
import FormFoot from './components/FormFoot';
// import { ENDPOINT_TOKEN } from '../../components/OnlineForm/helpers/HandleFieldChange.jsx';


const OnlineFormPage3 = ({ language, formData, setFormData, onNextPage, onPrevPage }) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const [diseases, setDiseases] = useState([...formData.conditions]);

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const response = await fetch(`https://vipe.uy/services/get_sponsors.php`)
        const data = await response.json();
        setLogos(data.logos);
      } catch (error) {
      }
    };

    fetchLogos();
  }, []);

  const handleAddDisease = () => {
    if (diseases.length < 3) {
      setDiseases([...diseases, { diseaseName: '', medication: { medicationName: '', dosage: '', frequency: '' }, showMedication: false }]);
    }
  };

  const handleAddMedication = (index) => {
    const newDiseases = [...diseases];
    newDiseases[index].showMedication = true;
    setDiseases(newDiseases);
  };

  const handleRemoveMedication = (index) => {
    const newDiseases = [...diseases];
    newDiseases[index].medication = { medicationName: '', dosage: '', frequency: '' };
    newDiseases[index].showMedication = false;
    setDiseases(newDiseases);

    // Actualizar medicación en formData
    const newFormData = { ...formData };
    if (newFormData.conditions[index] != null) {
      newFormData.conditions[index].medication = [{ medicationName: '', dosage: '', frequency: '' }];
    }
    setFormData(newFormData);
  };

  const handleRemoveDisease = (index) => {
    const newDiseases = [...diseases];
    newDiseases.splice(index, 1);
    setDiseases(newDiseases);

    // Eliminar antecedente de salud de formData
    const newFormData = { ...formData };
    newFormData.conditions.splice(index, 1);
    setFormData(newFormData);
  };

  const handleInputChange = (newValue, diseaseIndex) => {
    const updatedDiseases = diseases.map((disease, index) => {
      if (index === diseaseIndex) {
        return { ...disease, diseaseName: newValue };
      }
      return disease;
    });
    setDiseases(updatedDiseases);
  
    // Actualizar enfermedad en formData
    const updatedConditions = [...formData.conditions];
    if (updatedConditions.length <= diseaseIndex) {
      for (let i = updatedConditions.length; i <= diseaseIndex; i++) {
        updatedConditions.push({ diseaseName: '', medication: { medicationName: '', dosage: '', frequency: '' } });
      }
    }
    updatedConditions[diseaseIndex] = { ...updatedConditions[diseaseIndex], diseaseName: newValue };
    const updatedFormData = { ...formData, conditions: updatedConditions };
    setFormData(updatedFormData);
  };


  const handleMedicationInputChange = (event, diseaseIndex) => {
    const { name, value } = event.target;
    const newDiseases = [...diseases];
    newDiseases[diseaseIndex].medication[name] = value;
    setDiseases(newDiseases);

    // Actualizar medicación en formData
    
    const newFormData = { ...formData };
    newFormData.conditions[diseaseIndex].medication[name] = value;
    setFormData(newFormData);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let formErrors = {};

    formErrors = handleError(formData);

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      onNextPage();
    }
  };

  return (
    <>
      <FormHeader 
        language={language}
      />
      <form className='mainFormContainer' onSubmit={handleSubmit}>
      <h4 style={{fontWeight: 'lighter', textAlign: 'justify', maxWidth: '75%'}}>{t('wordings.importantInformation')}</h4>
        {diseases.map((disease, index) => (
          <div key={index} className='dynamic-div'>
            <label className='formLabel-disease'>
              {t('form.diseaseName')}
              <Disease
                language={language}
                value={disease.diseaseName}
                onChange={(value) => handleInputChange(value, index)}
                error={errors.diseaseName}
              />
            </label>
            <br />
            {disease.showMedication && (
              <div className='dynamic-med-div'>
                <label className='formLabel' style={{marginBottom: '8px'}}>{t('form.medicationWording')}</label>
                <label className='formLabel'>
                  {t('form.medicationName')}
                  <input className='textField'
                    type="text"
                    name={`medicationName`}
                    value={disease.medication.medicationName}
                    onChange={(e) => handleMedicationInputChange(e, index)}
                  />
                  {errors && <span className="errorMessage">{errors.medicationName}</span>}
                </label>
                <br />
                <label className='formLabel'>
                  {t('form.dosage')}
                  <input className='textField'
                    type="text"
                    name={`dosage`}
                    value={disease.medication.dosage}
                    onChange={(e) => handleMedicationInputChange(e, index)}
                  />
                  {errors && <span className="errorMessage">{errors.dosage}</span>}
                </label>
                <br />
                <label className='formLabel'>
                  {t('form.frequency')}
                  <select className='textField-select'
                    name={`frequency`}
                    value={disease.medication.frequency}
                    onChange={(e) => handleMedicationInputChange(e, index)}>
                    <option value=''>{t('form.select')}</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                    <option value='5'>5</option>
                    <option value='6'>6</option>
                  </select>
                  {errors && <span className="errorMessage">{errors.frequency}</span>}
                </label>
                <br />
                <button type="button" className='rem-med-btn' onClick={() => handleRemoveMedication(index)}>
                  {t('form.removeMedication')}
                </button>
              </div>
            )}
            {!disease.showMedication && disease.diseaseName && (
              <button type="button" className='add-med-btn' onClick={() => handleAddMedication(index)}>
                {t('form.addMedication')}
              </button>
            )}
            <div className='disease-btn'>
              {diseases.length > 1 && (
                <button type="button" className='rem-dis-btn' onClick={() => handleRemoveDisease(index)}>
                  {t('form.removeDisease')}
                </button>
              )}
              {
                diseases.length < 3 && (
                  <button type="button" className='add-dis-btn' onClick={handleAddDisease}>
                    {t('form.addDisease')}
                  </button>
                )
              }
            </div>
          </div>
        ))}

        <label className='formLabel' style={{marginTop: '25px'}}>
          {t('form.commentary')}
          <label className='formLabelSmall' style={{marginLeft: '2%'}}>{t('errors.max200char')}</label>
          <textarea
            className='textField' // Clase CSS para estilos adicionales
            name={`commentary`}
            value={formData.commentary}
            onChange={(e) => handleFieldChange(formData, setFormData, "commentary", e.target.value)} // Extrae e.target.value
            rows={4} // Establece el número de filas visibles del textarea
            style={{
              resize: 'vertical',
              minHeight: '100px', // Altura mínima del textarea
              maxHeight: '200px', // Altura máxima del textarea
            }}
          />
          {errors.commentary && <span className="errorMessage">{errors.commentary}</span>}
        </label>

        <br />
        <label className='formLabel'>
        {t('form.promotionalCode')}
          <select className='textField-select'
            name={`promotionalCode`}
            value={formData.promotionalCode}
            onChange={(e) => handleFieldChange(formData, setFormData, 'promotionalCode', e.target.value)}
            >
          <option value="">{t('form.select')}</option>
          {logos.map((logo, index) => (
            <option key={index} value={logo.empresaMostrar}>
              {logo.empresaMostrar}
            </option>
          ))}
          </select>
          {errors && <span className="errorMessage">{errors.frequency}</span>}
        </label>
        <br />
        <div className='next-back-div'>
          <button className='square-button-back' type="button" onClick={onPrevPage}>
            <span className="button-text">{t('form.previous')}</span>
          </button>
          <button className='square-button-next' type="submit">
            <span className="button-text">{t('form.next')}</span>
          </button>
        </div>
      </form>
      <FormFoot
        language={language}
      />
    </>
  );  

  function handleError(formData) {
    const formErrors = {};
    formData.conditions.forEach((condition) => {
      let { medication, showMedication } = condition;

      if (medication && showMedication) {
        if (!/^[a-zA-Z0-9]+$/.test(medication.medicationName) && medication.medicationName) {
            formErrors.medicationName = t('errors.onlyLettersNumbers');
        }
        if (medication.medicationName && medication.medicationName.length > 15) {
            formErrors.medicationName = t('errors.max15char')
        }

        if (medication.dosage && !/^[a-zA-Z0-9]+$/.test(medication.dosage)  ) {
            formErrors.dosage = t('errors.onlyLettersNumbers');
        }
        if (medication.dosage && medication?.dosage?.length > 8) {
            formErrors.dosage = t('errors.max8char')
        }
      }

    });

    if (formData.commentary) {
      if(formData.commentary.length > 200) {
        formErrors.commentary = t('errors.max200char')
      }
  
      if (!/^[a-zA-Z0-9 \n:;,.]+$/.test(formData.commentary)) {
        formErrors.commentary = t('errors.onlyLettersNumbers')
      }
  
      if ((formData.commentary.match(/\n/g) || []).length > 3) {
        formErrors.commentary = t('errors.max4lineBreak')
      }
    }

    return formErrors;
  }
  
};

export default OnlineFormPage3;
